import Vue from 'vue'
import Router from 'vue-router'
import LoadView from '@/components/LoadView'
import MainView from '../components/MainView'
import LetterView from '../components/LetterView'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LoadView',
      component: LoadView
    },
    {
      path: '/main',
      name: 'Main',
      meta: {
        requireAuth: true
      },
      component: MainView
    },
    {
      path: '/letter/:token?',
      name: 'Letter',
      meta: {
        requireAuth: true
      },
      component: LetterView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js